import styled, { css } from 'styled-components';
import { Text } from '@amzn/storm-ui';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

interface PageHeaderWrapperProps extends StyledComponentsPropWithTheme {
  isMobileDevice: boolean;
  shouldShiftAppWrapper?: boolean;
}

export const PageHeaderWrapper = styled.div<PageHeaderWrapperProps>`
  position: relative !important;
  width: ${({ shouldShiftAppWrapper }) =>
    shouldShiftAppWrapper ? 'calc(100% - 60px)' : '100%'};
  height: auto;
  box-sizing: border-box;
  margin: 0;
  background-color: ${(props: StyledComponentsPropWithTheme) =>
    props.theme.header.pageHeader.background};
  z-index: 1;
  box-shadow: 0px 2px 2px -1px rgba(0, 0, 0, 0.1);
  margin-inline-start: ${({ shouldShiftAppWrapper }) =>
    shouldShiftAppWrapper ? '60px' : null};
`;

export const PageTitle = styled.span<{
  isMobile?: boolean;
  hasObjectType?: boolean;
}>`
  padding-left: 7px;
  font-weight: bold;
  font-family: 'AmazonEmber-Bold', 'Amazon Ember', Arial, Helvetica, sans-serif !important;

  ${(props) =>
    props.isMobile &&
    css`
      padding-left: 0;
      word-break: break-word;
    `}

  ${(props) =>
    props.hasObjectType &&
    css`
      margin-left: 4px;
    `}
`;

export const PageTitleWrap = styled.div<{
  hasActions: boolean;
  hasAttributes: boolean;
  isMobile: boolean;
  hasPageTitleIcon: boolean;
}>`
  ${(props) =>
    isContainerFlexLayout(props) &&
    css`
      flex-grow: 1;
    `}

  ${(props) =>
    props.hasPageTitleIcon &&
    css`
      display: flex;
    `}
`;

interface PageTitleWrapperProps {
  isMobileDevice: boolean;
}

export const PageTitleWrapper = styled.div<PageTitleWrapperProps>`
  ${(props) =>
    props.isMobileDevice ? 'margin: 22px 0 5px 0' : 'padding-bottom: 26px'};
`;

const isContainerFlexLayout = (props: {
  hasActions: boolean;
  hasAttributes: boolean;
  isMobile: boolean;
}) => props.hasActions && !props.hasAttributes && !props.isMobile;

export const Container = styled.div<{
  hasActions: boolean;
  hasAttributes: boolean;
  isMobile: boolean;
}>`
  padding: 0 20px;

  ${(props) =>
    isContainerFlexLayout(props) &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      margin-top: ${({ theme }) => theme.spacing.small};
    `}
`;

export const Details = styled.div<{
  hasActions: boolean;
  hasAttributes: boolean;
  isMobile: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(props) =>
    (props.hasAttributes || props.hasActions) &&
    css`
      padding-bottom: 18px;
    `}

  ${(props) =>
    isContainerFlexLayout(props) &&
    css`
      padding-top: 18px;
    `}

  ${(props) =>
    props.hasActions &&
    css`
      margin-left: 50px;
    `}

  ${(props) =>
    props.hasAttributes &&
    props.hasActions &&
    css`
      flex-wrap: wrap;
      gap: 18px;
      margin-left: 0;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      display: block;
      margin-left: 0;
    `}
`;

export const TitleText = styled(Text)<{
  titleIconExists: boolean;
}>`
  display: inline-flex;
  align-items: center;

  &&& {
    padding: 18px 0;
  }

  ${(props) =>
    props.titleIconExists &&
    css`
      display: inline-flex;
      align-items: center;
    `}
`;

export const popoverThemeOverride = (theme) => ({
  ...theme,
  popover: {
    ...theme?.popover,
    zIndex: 500,
  },
  modal: {
    ...theme?.modal,
    zIndex: 500,
  },
});

export const RodeoContainer = styled.div`
  display: none;
`;

export const TitleIconContainer = styled.span<{
  pageNameTagExists: boolean;
  toggled: boolean;
}>`
  ${(props) =>
    props.pageNameTagExists
      ? css`
          margin-left: ${({ theme }) => theme.spacing.none};
        `
      : css`
          margin-left: ${({ theme }) => theme.spacing.micro};
        `}

  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;
  font-size: 1.4rem;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.palette.gray[200]};
  }

  & > * {
    color: ${({ theme, toggled }) =>
      toggled ? theme.palette.blue[700] : 'inherit'};
    opacity: ${({ toggled }) => (toggled ? 1 : 0.5)};
  }
`;
